<template>
  <div class="list-panel app-container calendar-list-container">
    <basic-container>
      <el-row :gutter="20">
        <el-col :span="4"
                style='margin-top:15px;'>
          <el-card class="box-card" shadow="never">
            <div class="clearfix" slot="header">
              <span>菜单</span>
              <el-button @click="searchTree=(searchTree ? false:true)" class="card-heard-btn" icon="icon-filesearch"
                         title="搜索"
                         type="text"></el-button>
              <el-button @click="getTreeMenu()" class="card-heard-btn" icon="icon-reload" title="刷新"
                         type="text"></el-button>
            </div>
            <el-input placeholder="输入关键字进行过滤"
                      v-model="filterTreeMenuText"
                      v-show="searchTree">
            </el-input>
            <el-tree
              :data="treeMenuData"
              :expand-on-click-node="false"
              :filter-node-method="filterNode"
              @node-click="clickNodeTreeData"
              class="filter-tree"
              highlight-current
              node-key="id"
              ref="leftMenuTree">
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="20">
          <div class="filter-container" v-show="searchFilterVisible">
            <el-form :inline="true" :model="searchForm" ref="searchForm">
              <el-form-item label="名称" prop="name">
                <el-input class="filter-item input-normal" size="small" v-model="searchForm.name" @keyup.enter.native="handleFilter"></el-input>
              </el-form-item>
              <el-form-item label="VUE页面" prop="component">
                <el-input class="filter-item input-normal" size="small" v-model="searchForm.component" @keyup.enter.native="handleFilter"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="handleFilter" icon="el-icon-search" size="small" type="primary">查询</el-button>
                <el-button @click="searchReset" icon="icon-rest" size="small">重置</el-button>
              </el-form-item>
            </el-form>

          </div>
          <!-- 表格功能列 -->
          <div class="table-menu">
            <div class="table-menu-left">

              <el-button-group>
                <el-button @click="handleEdit" icon="el-icon-plus" size="mini" type="primary" v-if="sys_menu_edit">添加
                </el-button>
                <el-button @click="handleEditSort" icon="icon-up-circle" size="mini" type="primary"
                           v-if="sys_menu_edit">更新序号
                </el-button>
              </el-button-group>
            </div>
            <!-- <div class="table-menu-right">
              <el-button @click="searchFilterVisible= !searchFilterVisible" circle icon="el-icon-search"
                         size="mini"></el-button>
            </div> -->
          </div>
          <el-table :data="list" :default-sort="{prop:'menu.sort',order:'ascending'}" :key='tableKey'
                    @sort-change="sortChange" element-loading-text="加载中..."
                    fit highlight-current-row v-loading="listLoading">
            <el-table-column fixed="left" type="index" width="40"></el-table-column>
            <el-table-column align="center" label="名称" prop="menu.name" sortable="custom">
              <template slot-scope="scope">
                <span>
                  <i :class="scope.row.icon"></i>
                  {{scope.row.name}}
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="上级菜单">
              <template slot-scope="scope">
                <span>{{scope.row.parentName}}</span>
              </template>
            </el-table-column> -->
            <el-table-column align="center" label="菜单类型">
              <template slot-scope="scope">
                <span>{{scope.row.typeText}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="权限" min-width="120">
              <template slot-scope="scope">
                <span>{{scope.row.permission}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="VUE页面" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{scope.row.component}}</span>
              </template>
            </el-table-column>
            <!--            <el-table-column align="center" label="路由缓冲" width="80">-->
            <!--              <template slot-scope="scope">-->
            <!--                <span>{{scope.row.keepAliveText}}</span>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column align="center" label="前端URL" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{scope.row.path}}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="是否显示">
              <template slot-scope="scope">
                <el-tag>{{scope.row.showText}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="序号" prop="menu.sort" sortable="custom" min-width="120">
              <template slot-scope="scope">
                <span>
                  <el-input-number :ref="'sort'+scope.row.id" :step="5" size="small"
                                   v-model="scope.row.sort"></el-input-number>
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="创建时间" prop="menu.created_date" sortable="custom" min-width="120">
              <template slot-scope="scope">
                <span>{{scope.row.createdDate}}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" fixed="right" label="操作"
                             v-if="sys_menu_edit || sys_menu_lock || sys_menu_del"
                             width="100">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row)" icon="icon-edit" type="primary" title="编辑" size="mini" circle  v-if="sys_menu_edit">
                </el-button>
                <el-button @click="handleDelete(scope.row)" icon="icon-delete" type="danger" title="删除" size="mini" circle
                           v-if="sys_menu_del">
                </el-button>
              </template>
            </el-table-column>

          </el-table>
          <div class="pagination-container" v-show="!listLoading">
            <el-pagination :current-page.sync="listQuery.current" :page-size="listQuery.size"
                           :page-sizes="[10,20,30, 50]"
                           :total="total" @current-change="handleCurrentChange"
                           @size-change="handleSizeChange" background
                           class="pull-right" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
      <el-dialog :visible.sync="dialogMenuVisible" title="选择菜单">
        <el-input placeholder="输入关键字进行过滤"
                  v-model="filterParentTreeMenuText">
        </el-input>
        <el-tree :data="treeMenuSelectData" :default-checked-keys="checkedKeys" :filter-node-method="filterNode"
                 @node-click="clickNodeSelectData"
                 check-strictly
                 class="filter-tree" default-expand-all highlight-current node-key="id"
                 ref="selectParentMenuTree">
        </el-tree>
      </el-dialog>

      <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
        <el-form :model="form" label-width="100px" ref="form">
          <el-form-item label="所属菜单" prop="parentName">
            <el-input :disabled="disableSelectMenuParent" @focus="handelParentMenuTree()" placeholder="选择菜单"
                      readonly v-model="form.parentName">
            </el-input>
            <input type="hidden" v-model="form.parentId"/>
          </el-form-item>

          <el-form-item :rules="[{required: true,message: '请输入菜单名称'}]" label="名称" prop="name">
            <el-input placeholder="请输入名称" v-model="form.name"></el-input>
          </el-form-item>

          <el-form-item :rules="[ {validator:validateUnique}]" label="权限" prop="permission">
            <el-input placeholder="请输入权限" v-model="form.permission"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="icon">
            <el-input v-model="form.icon"></el-input>
          </el-form-item>
          <el-form-item label="VUE页面" prop="component">
            <el-input v-model="form.component"></el-input>
          </el-form-item>
          <el-form-item :rules="[{required: true,message: '请选择' }]" label="菜单类型" prop="type">
            <crud-radio :dic="menuTypeOptions" v-model="form.type"></crud-radio>
          </el-form-item>
          <!--          <el-form-item label="路由缓冲" prop="keepAlive">-->
          <!--            <el-switch-->
          <!--              v-model="form.keepAlive"-->
          <!--              active-color="#13ce66" inactive-color="#ff4949" active-value="1" inactive-value="0">-->
          <!--            </el-switch>-->
          <!--          </el-form-item>-->
          <el-form-item label="前端URL" prop="path">
            <el-input v-model="form.path"></el-input>
          </el-form-item>
          <el-form-item :rules="[{required: true,message: '请选择' }]" label="是否显示" prop="show">
            <crud-radio :dic="flagOptions" v-model="form.show"></crud-radio>
          </el-form-item>
          <el-form-item label="序号" prop="sort">
            <el-input-number size="small" :max="1000" :min="1" v-model="form.sort"></el-input-number>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input placeholder="" maxlength="300" show-word-limit type="textarea" v-model="form.description"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" slot="footer">
          <el-button @click="cancel()">取 消</el-button>
          <el-button @click="save()" type="primary">保 存</el-button>
        </div>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
  import menuService from "./menu-service";
  import {mapGetters} from 'vuex';
  import util from "@/util/util";
  import validate from "@/util/validate";

  export default {
    name: 'Menu',
    data() {
      return {
        treeMenuData: [],
        treeMenuSelectData: [],
        dialogMenuVisible: false,
        dialogFormVisible: false,
        searchFilterVisible: true,
        checkedKeys: [],
        list: null,
        total: null,
        listLoading: true,
        searchForm: {
          name: '',
          component: ''
        },
        listQuery: {
          current: 1,
          size: 20
        },
        formEdit: true,
        filterTreeMenuText: '',
        filterParentTreeMenuText: '',
        filterFormText: '',
        formStatus: '',
        flagOptions: [],
        menuTypeOptions: [],
        searchTree: false,
        labelPosition: 'right',
        disableSelectMenuParent: false,
        form: {
          name: undefined,
          parentId: undefined,
          permission: undefined,
          icon: undefined,
          component: undefined,
          type: undefined,
          keepAlive: undefined,
          show: undefined,
          path: undefined,
          sort: undefined,
          description: undefined
        },
        validateUnique: (rule, value, callback) => {
          validate.isUnique(rule, value, callback, '/sys/menu/checkByProperty?id=' + util.objToStr(this.form.id))
        },
        dialogStatus: 'create',
        textMap: {
          update: '编辑',
          create: '创建'
        },
        sys_menu_edit: false,
        sys_menu_lock: false,
        sys_menu_del: false,
        currentNode: {},
        tableKey: 0
      }
    },
    watch: {
      filterTreeMenuText(val) {
        this.$refs['leftMenuTree'].filter(val);
      },
      filterParentTreeMenuText(val) {
        this.$refs['selectParentMenuTree'].filter(val);
      },
    },
    created() {
      this.getTreeMenu();
      this.sys_menu_edit = this.permissions["sys_menu_edit"];
      this.sys_menu_lock = this.permissions["sys_menu_lock"];
      this.sys_menu_del = this.permissions["sys_menu_del"];
      this.flagOptions = this.dicts['sys_flag'];
      this.menuTypeOptions = this.dicts['sys_menu_type'];

    },
    computed: {
      ...mapGetters([
        "permissions", "dicts"
      ])
    },
    methods: {
      getList() {
        this.listLoading = true;
        this.listQuery.queryConditionJson = util.parseJsonItemForm([{
          fieldName: 'name', value: this.searchForm.name
        }, {
          fieldName: 'component', value: this.searchForm.component
        }, {
          fieldName: 'parent_id', value: this.searchForm.parentId, operate: 'eq'
        }]);
        menuService.page(this.listQuery).then(response => {
          this.list = response.data.records;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      sortChange(column) {
        if (column.order == "ascending") {
          this.listQuery.ascs = column.prop;
          this.listQuery.descs = undefined;
        } else {
          this.listQuery.descs = column.prop;
          this.listQuery.ascs = undefined;
        }
        this.getList()
      },
      getTreeMenu() {
        menuService.fetchTree().then(response => {
          this.treeMenuData = util.parseTreeData(response.data);
          this.currentNode = this.treeMenuData[0];
          this.searchForm.parentId = this.treeMenuData[0].id;
          setTimeout(() => {
            this.$refs['leftMenuTree'].setCurrentKey(this.searchForm.parentId);
          }, 100);
          this.getList();
        })
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1
      },
      clickNodeTreeData(data) {
        this.searchForm.parentId = data.id;
        this.currentNode = data;
        this.getList()
      },
      clickNodeSelectData(data) {
        this.form.parentId = data.id;
        this.form.parentName = data.label;
        this.dialogMenuVisible = false;
      },
      handelParentMenuTree() {
        menuService.fetchTree({extId: this.form.id}).then(response => {
          this.treeMenuSelectData = util.parseTreeData(response.data);
          this.dialogMenuVisible = true;
          setTimeout(() => {
            this.$refs['selectParentMenuTree'].setCurrentKey(this.form.parentId ? this.form.parentId : null);
          }, 100);
        });
      },
      //搜索清空
      searchReset() {
        this.$refs['searchForm'].resetFields();
        this.searchForm.parentId = undefined;
        this.$refs['leftMenuTree'].setCurrentKey(null);
        this.currentNode = undefined;
        this.handleFilter();
      },
      handleFilter() {
        this.listQuery.current = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.size = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.current = val;
        this.getList();
      },
      handleEdit(row) {
        this.resetForm();
        this.dialogStatus = row && validate.checkNotNull(row.id) ? "update" : "create";
        if (this.dialogStatus == "create") {
          if (this.currentNode) {
            this.form.parentId = this.currentNode.id;
            this.form.parentName = this.currentNode.label;
          }
          this.dialogFormVisible = true;
        } else {
          menuService.find(row.id).then(response => {
            this.form = response.data;
            this.disableSelectMenuParent = this.form.parentName ? false : true;
            this.form.show = util.objToStr(this.form.show);
            this.dialogFormVisible = true;
          });
        }
      },
      handleEditSort() {
        let sortData = [];
        this.list.forEach(item => {
          sortData.push({id: item.id, sort: this.$refs["sort" + item.id].value})
        });
        menuService.sortUpdate({"menuSortVoList": sortData}).then(response => {
          this.getList()
        })
      },
      handleLock: function (row) {
        menuService.lock(row.id).then(response => {
          this.getList();
        });
      },
      handleDelete(row) {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          menuService.remove(row.id).then(response => {
            this.getList();
          })
        })
      },
      save() {
        this.$refs['form'].validate(valid => {
          if (valid) {
            menuService.save(this.form).then(response => {
              this.getList();
              this.dialogFormVisible = false;
            })
          } else {
            return false;
          }
        });
      },
      cancel() {
        this.dialogFormVisible = false;
        this.$refs['form'].resetFields();
      },
      resetForm() {
        this.form = {
          name: undefined,
          parentId: undefined,
          permission: undefined,
          icon: undefined,
          component: undefined,
          type: undefined,
          keepAlive: undefined,
          show: undefined,
          path: undefined,
          sort: undefined,
          description: undefined
        };
        this.$refs['form'] && this.$refs['form'].resetFields();
      }
    }
  }
</script>

